import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputIconModule } from 'primeng/inputicon';

@Component({
    selector: 'app-profile-validation-icon',
    imports: [InputIconModule],
    templateUrl: './profile-validation-icon.component.html',
    styleUrl: './profile-validation-icon.component.scss'
})
export class ProfileValidationIconComponent {
  @Input() control:AbstractControl|null

}
